import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import { useContext } from 'react'

import { AppContext } from './AppContext/AppContext'

function LockedPositionsEmptyState() {
  const { t } = useTranslation()
  const {
    query: { shortName }
  } = useRouter()
  const {
    state: {
      wallet: { connected }
    }
  } = useContext(AppContext)

  return (
    <div className="bg-block flex flex-col items-center space-y-6 px-10 py-10 text-white">
      <Image
        alt="No positions"
        height={140}
        src="/empty-state.gif"
        width={165}
      />
      <p className="lg:px-30 text-center">
        <Trans
          components={{ 0: <br /> }}
          i18nKey="locking-positions.empty-text"
        />
      </p>

      <Link
        className={`bg-teal-primary rounded-lg px-7 py-1 text-white ${
          !connected ? 'cursor-not-allowed opacity-50' : ''
        }`}
        href={`${connected ? `/${shortName}/lock-met` : '#'}`}
      >
        {t('locking-positions.empty-button-label')}
      </Link>
    </div>
  )
}

export default LockedPositionsEmptyState
